import { render } from "./DashboardCardSkeleton.vue?vue&type=template&id=be493a0c"
import script from "./DashboardCardSkeleton.vue?vue&type=script&lang=js"
export * from "./DashboardCardSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__